export enum Debounce {
  API_DEBOUNCE = 600,
}
